import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import { Add, Edit, GetAll, Remove } from '../../../configurations/crud/doctorsFastNoteCurd'
import { MdDelete, MdErrorOutline, MdAdd, MdRefresh, MdSearch, MdClose, MdOutlineSpeakerNotes, MdOutlineLowPriority } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { RiEditBoxFill } from 'react-icons/ri'
import PagingEmpty from '../../controls/PagingEmpty'
import { CiLocationArrow1 } from 'react-icons/ci'
import DeleteFastNoteModal from './DeleteFastNoteModal'
import AddFastNoteModal from './AddFastNoteModal'
import EditFastNoteModal from './EditFastNoteModal'
import Card from '../../controls/Card'
import useGlobalLoader from '../../../configurations/useGlobalLoader'


export default function ViewFastNotes() {
  const { start, end } = useGlobalLoader()
  const [FastNotesData, setFastNotesData] = useState([])
  const [loding, setLoding] = useState(false)
  const toast = useToast()
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [filterText, setFilterText] = useState("")

  const [editData, setEditData] = useState({
    id: 0,
    note: "",
    priority: "0",
  })

  useEffect(() => {
    GetFastNotes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GetFastNotes = () => {
    setLoding(true)
    start()
    GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setFastNotesData(mdata.data)
      } else {
        setFastNotesData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setFastNotesData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const AddFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Add(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          note: "",
          priority: "0",
        })
        setIsOpenAdd(false)
        GetFastNotes()
        toast.open("FastNote added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const EditFastNote = (param, setValues) => {
    setLodingCrud(true)
    start()
    Edit(param).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setValues({
          id: 0,
          note: "",
          priority: "0",
        })
        setIsOpenEdit(false)
        GetFastNotes()
        toast.open("FastNote updated successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const DeleteFastNote = (id) => {
    setLodingCrud(true)
    start()
    Remove(id).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setIsOpenDelete(false)
        GetFastNotes()

        toast.open("FastNotes deleted successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // client-side filter (does not touch the API data)
  const visibleNotes = filterText
    ? FastNotesData.filter(item =>
      String(item.note).toLowerCase().includes(filterText.toLowerCase()))
    : FastNotesData

  // edit + delete actions (shared by table + cards)
  const renderActions = (item) => (
    <>
      <button
        type="button"
        title="Edit"
        onClick={() => { setEditData(item); setIsOpenEdit(!isOpenEdit) }}
        className="grid h-9 w-9 place-items-center rounded-lg text-brand-600 transition hover:bg-brand-50 active:scale-95"
      >
        <RiEditBoxFill className="text-xl" />
        <span className="sr-only">Edit</span>
      </button>
      <button
        type="button"
        title="Delete"
        onClick={() => { setEditData(item); setIsOpenDelete(!isOpenDelete) }}
        className="grid h-9 w-9 place-items-center rounded-lg text-red-600 transition hover:bg-red-50 active:scale-95"
      >
        <MdDelete className="text-xl" />
        <span className="sr-only">Delete</span>
      </button>
    </>
  )

  return (
    <Container title={"Manage Fast Notes"}>
      <div className="w-full px-2 sm:px-4">
        <Card
          isBorder={true}
          title={
            <div className="flex w-full items-center gap-2">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-brand-500 text-white shadow-sm">
                <MdOutlineSpeakerNotes className="text-base" />
              </span>
              <div className="min-w-0 leading-tight">
                <span className="block truncate">Manage Fast Notes</span>
                <span className="block truncate text-xs font-normal text-gray-500">
                  {loding ? "Loading..." : `${FastNotesData.length} note${FastNotesData.length == 1 ? "" : "s"}`}
                </span>
              </div>
            </div>
          }
        >

          {/* toolbar: new + search + refresh */}
          <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <button
              onClick={() => setIsOpenAdd(!isOpenAdd)}
              className="inline-flex items-center justify-center gap-2 self-start rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-brand transition hover:brightness-105 active:scale-95"
            >
              <MdAdd className="text-lg" /> New Note
            </button>

            <div className="flex w-full items-center gap-2 sm:max-w-xs">
              <div className="relative w-full">
                <MdSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-gray-400" />
                <input
                  type="text"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Filter notes..."
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 pl-10 pr-9 text-sm text-gray-900 outline-none focus:border-brand-400 focus:ring-brand-400"
                />
                {filterText &&
                  <button
                    type="button"
                    onClick={() => setFilterText("")}
                    className="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full text-gray-400 transition hover:bg-gray-200 hover:text-gray-600"
                  >
                    <MdClose className="text-base" />
                    <span className="sr-only">Clear filter</span>
                  </button>
                }
              </div>
              <button
                type="button"
                onClick={GetFastNotes}
                title="Refresh"
                className="grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-gray-200 bg-white text-gray-500 shadow-sm transition hover:bg-gray-50 hover:text-gray-700 active:scale-95"
              >
                <MdRefresh className="text-lg" />
                <span className="sr-only">Refresh</span>
              </button>
            </div>
          </div>

          <PagingEmpty count={FastNotesData.length}>
            {!loding ? (
              FastNotesData.length > 0 ? (
                visibleNotes.length > 0 ? (
                  <>
                    {/* desktop table */}
                    <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                      <table className="w-full border-collapse text-left text-sm text-gray-500">
                        <thead>
                          <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                            <th scope="col" className="px-5 py-3 font-semibold">#</th>
                            <th scope="col" className="px-5 py-3 font-semibold">
                              <span className="flex items-center gap-1.5"><MdOutlineSpeakerNotes className="text-sm" /> Note</span>
                            </th>
                            <th scope="col" className="px-5 py-3 font-semibold">
                              <span className="flex items-center gap-1.5"><MdOutlineLowPriority className="text-sm" /> Priority</span>
                            </th>
                            <th scope="col" className="px-5 py-3 text-right font-semibold">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                          {visibleNotes.map((item, index) => (
                            <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                              <td className="px-5 py-2.5 text-gray-500">{index + 1}</td>
                              <td className="px-5 py-2.5 font-medium text-gray-800">{item.note}</td>
                              <td className="px-5 py-2.5">
                                <span className="rounded-md bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">{item.priority}</span>
                              </td>
                              <td className="px-5 py-2.5">
                                <div className="flex items-center justify-end gap-1">{renderActions(item)}</div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* mobile cards */}
                    <div className="space-y-2 sm:hidden">
                      {visibleNotes.map((item, index) => (
                        <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                          <div className="flex items-start justify-between gap-2">
                            <div className="min-w-0">
                              <div className="flex items-center gap-1 text-xs text-gray-400">
                                <span>#{index + 1}</span>
                                <span>·</span>
                                <MdOutlineLowPriority className="text-sm" />
                                <span>Priority <span className="font-semibold text-brand-700">{item.priority}</span></span>
                              </div>
                              <div className="mt-0.5 font-medium text-gray-800">{item.note}</div>
                            </div>
                            <div className="flex shrink-0 items-center gap-1">{renderActions(item)}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  /* notes exist but filter matched nothing */
                  <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-8 text-center">
                    <MdSearch className="text-2xl text-gray-400" />
                    <p className="text-sm font-medium text-gray-600">No notes match "{filterText}"</p>
                    <button
                      type="button"
                      onClick={() => setFilterText("")}
                      className="text-xs font-semibold text-brand-600 hover:underline"
                    >
                      Clear filter
                    </button>
                  </div>
                )
              ) : (
                <Empty>No Items Found.</Empty>
              )
            ) : (
              <LoadingContainer />
            )}
          </PagingEmpty>

          {/* modals */}
          <EditFastNoteModal isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} editData={editData} EditFastNote={EditFastNote} loding={lodingCrud} />
          <AddFastNoteModal AddFastNote={AddFastNote} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
          <DeleteFastNoteModal DeleteFastNote={DeleteFastNote} isOpen={isOpenDelete} setIsOpen={setIsOpenDelete} loding={lodingCrud} id={editData.id} name={editData.note} />
        </Card>
      </div>
    </Container>
  )
}